import { fromJS } from 'immutable';
import { setAuthToken, deleteAuthToken } from '../utils/token';
import {
    SESSION_GET,
    SESSION_GET_SUCCESS,
    SESSION_GET_FAILED,
    SESSION_POST,
    SESSION_POST_SUCCESS,
    SESSION_POST_FAILED,
    SESSION_RESET
} from '../actions/session';

const initialState = fromJS({
    isAuth: false,
    isFetching: false,
    isFailed: false,
    error: null,
    user: null
});

const session = (state = initialState, action) => {
    switch (action.type) {
        case SESSION_GET:
            return state.merge(
                {
                    isFetching: true,
                    isAuth: false
                }
            );

        case SESSION_GET_SUCCESS:
            return state.merge(
                {
                    isFetching: false,
                    isAuth: true,
                    isFailed: false,
                    user: action.user.data
                }
            );

        case SESSION_GET_FAILED:
            return state.merge(
                {
                    isFetching: false,
                    isFailed: true,
                    isAuth: false,
                    error: action.error
                }
            );

        case SESSION_POST:
            deleteAuthToken();

            return state.merge(
                {
                    isFetching: true
                }
            );

        case SESSION_POST_SUCCESS:
            setAuthToken(action.token, 1);

            return state.merge(
                {
                    isFetching: false
                }
            );

        case SESSION_POST_FAILED:
            return state.merge(
                {
                    isFailed: true,
                    isFetching: false,
                    error: action.error
                }
            );

        case SESSION_RESET:
            deleteAuthToken();
            return state.merge({...initialState.toJS()});

        default:
            return state;
    }
};

export default session;


/** WEBPACK FOOTER **
 ** ./src/reducers/session.js
 **/